<div class="journal-container">
  <div class="loading-state" *ngIf="isLoading">
    <p>Loading journal…</p>
  </div>

  <div class="error-state" *ngIf="!isLoading && loadError">
    <p>{{ loadError }}</p>
  </div>

  <ng-container *ngIf="!isLoading && !loadError">
    <div class="empty-state" *ngIf="journalEntries.length === 0">
      <p>No journal entries for this member.</p>
    </div>

    <div class="journal-list" *ngIf="journalEntries.length > 0">
      <div *ngFor="let entry of journalEntries" class="journal-card">
        <div class="card-row journal-header">
          <div class="logged-at" *ngIf="entry.modifiedDateTime">
            Logged at {{ formatLoggedAt(entry.modifiedDateTime) }}
          </div>
        </div>

        <div class="card-row journal-notes-row" *ngIf="entry.notes">
          <p class="notes-text notes-rich">
            <strong>Note:-</strong>
            <span class="notes-rich-body" [innerHTML]="getJournalNotesHtml(entry.notes)"></span>
          </p>
        </div>

        <!-- Audio Player -->
        <div class="card-row" *ngIf="entry.voiceUrl">
          <div class="audio-player">
            <button
              mat-icon-button
              class="play-pause-btn"
              (click)="toggleAudio(entry.voiceUrl!, entry.id)"
              [attr.aria-label]="playingAudios[entry.id] ? 'Pause' : 'Play'">
              <mat-icon>{{ playingAudios[entry.id] ? 'pause' : 'play_arrow' }}</mat-icon>
            </button>

            <div class="audio-waveform" [class.playing]="isAudioPlaying(entry.id)">
              <div
                class="waveform-bar"
                *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]">
              </div>
            </div>

            <span class="audio-duration">{{ getAudioDuration(entry.voiceUrl!, entry.id) }}</span>
          </div>
        </div>

        <!-- Images -->
        <div class="card-row" *ngIf="entry.imageUrls && entry.imageUrls.length > 0">
          <div class="images-container">
            <img
              *ngFor="let imageUrl of entry.imageUrls"
              [src]="imageUrl"
              [alt]="'Image from ' + (entry.modifiedDateTime || '')"
              class="thumbnail-image"
              (click)="openImageLightbox(imageUrl)"
            />
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Image Lightbox -->
<div class="lightbox-overlay" *ngIf="selectedImage" (click)="closeImageLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button mat-icon-button class="lightbox-close" (click)="closeImageLightbox()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
    <img [src]="selectedImage" alt="Full size image" class="lightbox-image" />
  </div>
</div>
